import {Injectable} from "@angular/core";
import {
  BarcodeScanner,
  BarcodeScannerOptions,
  BarcodeScanResult,
} from "@ionic-native/barcode-scanner";

@Injectable()
export class BarcodeScannerNative {

  constructor(
    private barcodeScanner: BarcodeScanner,
  ) {
  }

  scanCode(opt?: BarcodeScannerOptions): Promise<BarcodeScanResult> {
    return this.barcodeScanner.scan(opt);
  }

  encode(params: Encode): Promise<void> {
    return this.barcodeScanner.encode(params.type, params.data);
  }
}

interface Encode {
  type: 'TEXT_TYPE' | 'EMAIL_TYPE' | 'PHONE_TYPE' | 'SMS_TYPE';
  data: any;
}



// WEBPACK FOOTER //
// ./src/native/barcode-scanner.native.ts